export { default } from "./HistorialVentasMes";
